<template>
    <footer class="footer discount-search-footer">
        <div class="content is-flex is-justify-content-space-between is-align-items-center	">
            <div>
                {{
                    `${number_of_selected_products} ${__('strings.discount.of')} ${number_of_total_products} ${__('strings.discount.selected')}`
                }}
            </div>
            <div class="buttons">
                <b-button :disabled="isLoading" type="is-primary" class="is-uppercase" inverted
                        @click="$emit('toggleAddDiscountModal')">
                    {{ __('strings.discount.add_new_discount') }}
                </b-button>
                <b-button @click="$emit('openUploadModal')" type="is-primary" inverted class="is-uppercase">Upload Discount Plan</b-button>
                <b-dropdown position="is-top-left">
                    <template #trigger="{ active }">
                        <b-button :disabled="isLoading"  type="is-primary" inverted class="is-uppercase"
                                  :icon-right="active ? 'menu-up' : 'menu-down'">Export Discount Plan</b-button>
                    </template>
                    <b-dropdown-item @click="$emit('createProductPriceExport', {id:1})">New Export</b-dropdown-item>
                    <b-dropdown-item @click="$emit('openExportsModal')">Show exports</b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    props: {
        retailers: {
            required: true,
            type: Array
        },
        number_of_selected_products: {
            required: false,
            type: Number
        },
        number_of_total_products: {
            required: false,
            type: Number
        },
        isLoading: {
            required: false,
            type: Boolean,
            default: false
        }
    },
}
</script>
